/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Dec 30 2024
 **/

import { useState } from "react";

type SliderContentsProps = {
	thicknessRange: Bounds;
	onChange: (value: number) => void;
};

export default function SliderContent({ thicknessRange, onChange }: SliderContentsProps) {
	const [value, setValue] = useState<number>(thicknessRange.default);

	const handleChange = (e: HtmlMouseEvent) => {
		const targetValue = Number(e.target.value);
		setValue(targetValue);
		onChange(targetValue);
	};

	return (
		<input
			type="range"
			min={thicknessRange.min}
			max={thicknessRange.max}
			value={value}
			onChange={handleChange}
			style={{ width: "100%" }}
		/>
	);
}
